var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTuber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-tuber",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.034,
    height: 43.491,
    viewBox: "0 0 26.034 43.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 26.034,
    height: 43.491,
    fill: "#c4e7f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M.391,37.172a4.488,4.488,0,1,0,8.2,3.661L20.956,13.14l1.194.236,3.885-8.7L15.565,0l-3.9,8.734,1.063.814ZM13.929,22.1l-3.154-1.408,4.6-10.3L18.53,11.8Z",
    transform: "translate(0.001 0)",
    fill: "#c4e7f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTuber);
export default __webpack_public_path__ + "static/media/icon-tuber.1e2146f3df161d48ea3aa5083f651d27.svg";
export { ForwardRef as ReactComponent };